import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import {
  ACCEPTED,
  PENDING,
  ON_PAUSE,
  REJECTED,
  INACTIVE,
  TERMINATED,
  REJECTED_CAN_REAPPLY,
} from '../constants';

export const convertMentorStatus = (status) => {
  const statusMap = {};

  statusMap[ACCEPTED] = s__('Mentorships|Active');
  statusMap[PENDING] = s__('Mentorships|Pending request');
  statusMap[ON_PAUSE] = s__('Mentorships|On pause');
  statusMap[REJECTED] = s__('Mentorships|Rejected');
  statusMap[TERMINATED] = s__('Mentorships|Terminated');
  statusMap[INACTIVE] = s__('Mentorships|Available');
  statusMap[REJECTED_CAN_REAPPLY] = s__('Mentorships|Rejected can reapply');

  return statusMap[status] || status;
};

export const getDisplayValue = (type, value) => {
  try {
    if (
      value === undefined ||
      value === null ||
      type === undefined ||
      type === null
    ) {
      return '-';
    }

    switch (type) {
      case 'boolean':
        return value === true || value === 'true' ? __('Yes') : __('No');
      case 'select':
        return value.join(', ');
      case 'double_select':
        return Object.values(value).flat().join(', ');
      case 'date':
        return I18n.l('date.formats.long', value);
      default:
        return value;
    }
  } catch {
    return '-';
  }
};

export const getMentorLabel = (currentNetwork, topic) =>
  topic?.config?.mentor_label ||
  currentNetwork?.network_configuration?.mentorships?.mentor_label ||
  s__('Mentorships|Mentor');

export const getMenteeLabel = (currentNetwork, topic) =>
  topic?.config?.mentee_label ||
  currentNetwork?.network_configuration?.mentorships?.mentee_label ||
  s__('Mentorships|Mentee');

export const getMentorApplicationFormText = (currentNetwork, topic) =>
  topic?.config?.above_mentor_application_form_text ||
  currentNetwork?.network_configuration?.mentorships
    ?.above_mentor_application_form_text ||
  '';

export const getMenteeApplicationFormText = (currentNetwork, topic) =>
  topic?.config?.above_mentee_application_form_text ||
  currentNetwork?.network_configuration?.mentorships
    ?.above_mentee_application_form_text ||
  '';

export const getUserLocation = (user) => {
  const location = user.locations?.[0];

  return (
    [location?.city, location?.country].filter(Boolean).join(', ') ||
    location?.address
  );
};

export const getRelationship = ({ relationships, mentorId }) =>
  relationships.find(
    (r) => r?.mentor?.id === mentorId && [ACCEPTED, PENDING].includes(r.status),
  );

export const getRelationshipStatus = ({ relationships, mentorId }) => {
  const relationship = getRelationship({ relationships, mentorId });

  let status = INACTIVE;

  if (relationship) {
    if (relationship.startedAt) {
      status = ACCEPTED;
    } else {
      status = PENDING;
    }
  }

  return status;
};

export const getMentorApplicationConfig = (currentNetwork, topic = null) => {
  const config = topic?.config || currentNetwork?.network_config;

  const mentorshipsSkillsDisplayInMentorCard =
    config?.mentorships_skills_display_in_mentor_card;
  const mentorshipsLocationDisplayInMentorCard =
    config?.mentorships_location_display_in_mentor_card;
  const mentorshipsSkillsDisplayInSearchFilters =
    config?.mentorships_skills_display_in_search_filters;
  const mentorshipsKeywordDisplayInSearchFilters =
    config?.mentorships_keyword_display_in_search_filters;
  const mentorshipsLocationDisplayInSearchFilters =
    config?.mentorships_location_display_in_search_filters;

  return {
    mentorshipsSkillsDisplayInMentorCard,
    mentorshipsLocationDisplayInMentorCard,
    mentorshipsSkillsDisplayInSearchFilters,
    mentorshipsKeywordDisplayInSearchFilters,
    mentorshipsLocationDisplayInSearchFilters,
  };
};

export const fetchMentors = ({ config, fetchFilters, page, signal }) =>
  axios
    .get(config.routes.fetchMentors, {
      params: { ...fetchFilters, page },
      signal,
    })
    .then((response) => response.data);

export const fetchRelationships = ({ owner }) => {
  const route =
    owner.type === 'Topics::Topic'
      ? Routes.topics_topic_relationships_path(owner.id)
      : Routes.mentorships_relationships_path();

  return axios.get(route, {}).then((response) => response.data);
};

export const fetchCustomAttributesList = ({ owner }) => {
  const route =
    owner.type === 'Topics::Topic'
      ? Routes.customizable_attributes_list_topics_topic_mentors_path(owner.id)
      : Routes.customizable_attributes_list_mentorships_mentors_path();

  return axios.get(route).then((response) => response.data);
};
